const VoucherCampaignCurrency = {
  Peso: "peso",
  Liter: "liter",
  Points: "points",
};

export default VoucherCampaignCurrency;
